<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    LightExtraField: () => lazyLoadComponent(import('./LightExtraField')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      submitData: {},
      tryingFetchOrder: false,
      tryingStore: false,
      componentKey: 0,
    }
  },
  computed: {
    productId() {
      return this.$route.params.productId
    },
    submitRules() {
      return {
        title: [
          {
            required: true,
            message: '請選擇開賣日期',
            trigger: 'change',
          },
        ],
        qty: [
          {
            required: true,
            message: '請選擇開賣日期',
            trigger: 'change',
          },
        ],
        sizeTotal: [
          {
            required: true,
            message: '請選擇開賣日期',
            trigger: 'change',
          },
        ],
        used: [
          {
            required: true,
            message: '請選擇開賣日期',
            trigger: 'change',
          },
        ],
      }
    },
    lightInfo() {
      return this.defaultValue.params
        .map((param, key) => {
          return param.codes.map((code) => {
            return {
              ...code,
              customerInfo: unescape(code.customerInfo)
                .replace(/\\n(?!.*\\n)/g, '<br>')
                .replace(/\\n/g, ' '),
              title: param.title,
            }
          })
        })
        .reduce((acc, val) => acc.concat(val), [])
    },
    // 0 已取消 2 未付款
    isDisabled() {
      return [0, 2].includes(this.submitData.status)
    },
  },
  created() {
    this.tryToFetchOrder()
  },
  methods: {
    async tryToFetchOrder() {
      this.tryingFetchOrder = true
      const response = await this.$store.dispatch('order/fetchSingle', this.defaultValue.id)
      this.submitData = response
      this.tryingFetchOrder = false
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
    async tryToSaveOrder(merchantNote = '') {
      const storeData = {
        ...this.convertExtraFieldToStoreDataFromEditMode(this.submitData),
        merchantNote,
      }
      this.tryingStore = true
      try {
        await this.$store.dispatch('order/store', storeData)
        this.handleSaveSuccess()
      } catch (error) {
        console.log('TCL: tryToSaveOrder -> error', error)
      } finally {
        this.tryingStore = false
      }
    },
    handleSaveSuccess() {
      this.$message({
        message: '儲存成功！',
        type: 'success',
      })
    },
    onSave() {
      this.tryToSaveOrder()
    },
    convertExtraFieldToStoreDataFromEditMode(submitData) {
      const orderInfo = cloneDeep(submitData)
      const storeData = cloneDeep(this.$refs.extrafield.submitData)
      orderInfo.byOrderExtrafields = this.getExtraFieldsArray(storeData.byOrderExtrafields)
      orderInfo.bySizeExtrafields = this.getBySizeExtraFieldsArray(storeData.customerInfos)
      delete orderInfo.customerInfos
      return orderInfo
    },
    getBySizeExtraFieldsArray(customerInfos) {
      return customerInfos.map((customerInfo) => {
        return {
          customerInfoId: customerInfo.customerInfoId,
          orderExtrafields: this.getExtraFieldsArray(customerInfo.bySizeExtrafields),
        }
      })
    },
    getExtraFieldsArray(extraFields) {
      const extraFieldsArray = []
      Object.keys(extraFields).forEach((extraFieldsId) => {
        if (this.isEdited(extraFields[extraFieldsId])) {
          const { id, value } = extraFields[extraFieldsId]
          extraFieldsArray.push({ id, value })
        }
      })
      return extraFieldsArray
    },
    isEdited(field) {
      return field.edited === true
    },
    resetLightExtraField() {
      this.$refs.extrafield.resetEdit()
    },
    async onFinish() {
      await this.$confirm('訂單狀態變更為已完成後，將會寄發訊息給登記人。<br>請問是否確認繼續？', '確認', {
        confirmButtonText: '確 定',
        cancelButtonText: '取 消',
        type: 'warning',
        center: true,
        dangerouslyUseHTMLString: true
      })
      this.submitData.status = 4
      await this.tryToSaveOrder()
      this.$emit('refresh')
    },
  },
}
</script>

<template>
  <div v-loading="tryingFetchOrder">
    <template v-if="submitData.hasOwnProperty('id')">
      <el-row :gutter="10">
        <el-col :span="14"
          ><el-table ref="table" :data="lightInfo" border :class="$style['no-bottom']" :cell-style="{ height: '80px' }">
            <el-table-column v-slot="{ row }" label="燈種" width="150">
              <div>{{ row.title }}</div>
            </el-table-column>

            <el-table-column v-slot="{ row }" label="登記資訊">
              <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" v-html="row.customerInfo"></div>
            </el-table-column> </el-table
        ></el-col>
        <el-col :span="10">
          <LightExtraField v-if="submitData.hasOwnProperty('id')" :key="componentKey" ref="extrafield" :default-value="submitData" :disabled="isDisabled"></LightExtraField>
        </el-col>
      </el-row>

      <div v-show="!isDisabled" :class="$style.footer">
        <div :class="submitData.status === 4 ? $style['vs-hide'] : ''"><el-button type="primary" @click="onFinish">完成序號登記</el-button></div>
        <div
          ><el-button plain @click="resetLightExtraField">取消變更</el-button>
          <el-button type="primary" :loading="tryingStore" @click="onSave" plain>儲存變更</el-button>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" module>
.no-bottom {
  :global {
    .el-table__body tr:hover > td {
      background-color: transparent;
    }
    .el-form-item {
      margin-bottom: 20px !important;
    }
  }
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}
.vs-hide {
  visibility: hidden;
}
</style>
